import $ from 'jquery';
import {is_function} from '../../../Helpers/js/simple.functions';
import UI from '../0-ui';

//----------- //
// SLIDER UI  //
//----------- //
UI.Slider = {
  init: function (sliderRef, sliderInput, sliderText, minValue, maxValue, curValue, units, floating, stepSize, stepWidth, onChange) {
    var slider = $(sliderRef);
    var params = new Array();
    var reverse = minValue > maxValue;
    var scaleQuestionId = slider.attr('scaleQuestionId');
    var noSelectionTxt = slider.attr('data_no_selec_txt');
    var valueTxt = slider.attr('data-valuetext');
    const pollLang = $(sliderRef).closest('div[data-lang]').data('lang');
    const rtlLanguages = ['ar', 'fa', 'he'];
    if (rtlLanguages.includes(pollLang)) {
      params['isRTL'] = true;
    } else {
      params['isRTL'] = false;
    }
    params['min'] = reverse ? maxValue : minValue;
    params['max'] = reverse ? minValue : maxValue;

    if (curValue === '') {
      curValue = minValue + (maxValue - minValue) / 2;
    }

    var value = reverse ? minValue - (curValue - maxValue) : curValue;
    if (!value) {
      value = params['min'] + (params['max'] - params['min']) / 2;
    }

    if (floating) {
      params['step'] = stepWidth;
    } else if (stepSize != '') {
      params['step'] = stepSize;
    } else {
      params['step'] = 1;
    }

    params['value'] = value;
    params['create'] = function () {
      var handle = $(sliderRef + ' .ui-slider-handle');
      handle.attr('role', 'slider');
      handle.attr('aria-valuemin', minValue);
      handle.attr('aria-valuemax', maxValue);

      var Labelby = scaleQuestionId ? slider.attr('labelby') : slider.attr('labelby');
      handle.attr('aria-valuetext', noSelectionTxt);
      handle.attr('aria-labelledby', Labelby);

      if ($(sliderInput).val() === '') {
        handle.attr('initial', '1');
        slider.attr('initial', '1');
        handle.attr('aria-valuetext', noSelectionTxt);
        $(sliderRef).value = 0;
      } else {
        handle.attr('aria-valuetext', valueTxt + ' ' + $(sliderInput).val());
      }
      handle.append($('<span class="sliderTooltipWrapper"><span class="sliderTooltip bubble up"></span></span>'));
    };
    params['start'] = function (event, ui) {
      var val = reverse ? minValue - ui.value + maxValue : ui.value;
      slider.removeAttr('initial');
      $('.ui-slider-handle', slider).removeAttr('initial');
      $('.sliderTooltip', slider)
        .html(val + units)
        .css('display', 'inline-block');
    };
    params['stop'] = function () {
      $('.sliderTooltip', slider).hide();
    };
    params['change'] = function (event, ui) {
      var val = reverse ? minValue - ui.value + maxValue : ui.value;
      if (sliderInput) {
        $(sliderInput).val(val);
        $(sliderRef + ' .ui-slider-handle').attr('aria-valuetext', val !== '' ? val : noSelectionTxt);
        val !== '' && $(sliderRef + ' .ui-slider-handle').attr('aria-valuetext', valueTxt + ' ' + val);
        scaleQuestionId && $(sliderRef + ' .ui-slider-handle').attr('aria-describedby', val !== '' ? 'label_' + scaleQuestionId + '_' + val : '');
      }

      if (is_function(onChange)) {
        onChange();
      }
    };
    params['slide'] = function (event, ui) {
      var val = reverse ? minValue - ui.value + maxValue : ui.value;
      $('.sliderTooltip', slider).html(val + units);
    };
    params['range'] = 'min';

    slider.slider(params);
  },

  setValue: function (sliderRef, value) {
    $(sliderRef).slider('value', value);
  },
};
